import 'nprogress/nprogress.css'
import 'rc-slider/dist/rc-slider.css'
import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'
import React from 'react'
// import ReactDOM from 'react-dom'
import { createRoot } from 'react-dom/client'
import 'react-quill/dist/quill.snow.css'
import 'react-select/dist/react-select.css'
import { startSession } from '@futures-platform/connectors/session'
import { GlobalStyles } from '@futures-platform/ui'
import App from './App'
import './index.css'
import { DataProvider } from './store/GlobalState'
import { RadarStyles } from './styles'

const renderApp = (dataUri, isAuthed, type = 'news') => {
  const params = !!dataUri && dataUri?.split('/')
  if (!!params) {
    return (
      <React.StrictMode>
        <GlobalStyles />
        <RadarStyles />
        <DataProvider
          type={type}
          gid={params[1]}
          newsIdProp={params[2]}
          isAuthed={isAuthed}>
          <App
            newsIdProp={params[2]}
            gid={params[1]}
            isAuthed={isAuthed}
            type={type}
          />
        </DataProvider>
      </React.StrictMode>
    )
  }
}

try {
  startSession().then((a) => {
    const appElement = document.getElementById('spot-light-app')

    const root = createRoot(appElement)
    root.render(
      renderApp(
        appElement.getAttribute('data-uri'),
        a,
        appElement.getAttribute('data-type') || 'news',
      ),
    )
  })
} catch (error) {
  const appElement = document.getElementById('spot-light-app')

  const root = createRoot(appElement)
  root.render(renderApp(appElement.getAttribute('data-uri'), false))
  // root.render(renderApp(appElement.getAttribute('data-uri'), false))
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
